// Pixi 8.9.2 GlGeometrySystem.draw draws `size || indexBuffer.data.length` indices, so an
// empty batch (size 0) draws the whole index buffer: whatever stale geometry the batcher
// last uploaded shows up as a ghost shape. A filter pass around it usually clips it away;
// AG Groups that render straight into their parent at opacity 1 don't. A size-0 draw
// draws nothing.
import { GlGeometrySystem } from 'pixi.js';

const draw = GlGeometrySystem.prototype.draw;

GlGeometrySystem.prototype.draw = function drawNothingForSizeZero(topology, size, start, instanceCount) {
	if (size === 0) return this;
	return draw.call(this, topology, size, start, instanceCount);
};
